import LogoIcon from '@/app/assets/svg/logo.svg?react';
import { commonRoutes } from '@/app/providers/router/routes';
import { AppLink } from '@/app/shared/ui/AppLink';
import { useThemeStore } from '@/app/store/theme';

interface LogoProps {
  setIsModalOpen?: (isOpen: boolean) => void;
}

export const Logo = ({ setIsModalOpen }: LogoProps) => {
  const { theme } = useThemeStore();

  return (
    <AppLink to={commonRoutes.VAULTS} onClick={() => setIsModalOpen?.(false)}>
      {theme === 'light' ? (
        <LogoIcon className='text-logo h-5.5 w-40.5 xl:h-6 xl:w-44' />
      ) : (
        <img src='/logo-gold.svg' alt='Mezzanine' className='h-5.5 w-40.5 xl:h-6 xl:w-44' />
      )}
    </AppLink>
  );
};
